import {BaseStore} from './base.store';
import {InsightsSubMenu, MainPages, ProtectionMenuNameOptions} from '@src/utils/enums';
import {RootStore} from './index';
import {action, makeObservable, observable} from 'mobx';

import {BronzeTabName, EmailLinkSource, EventType} from '@src/dtos/analytics.dto';


export class UIStore extends BaseStore {
    public mainPage: MainPages | undefined = undefined;
    public systemDataLoaded = false;
    public emailLinkSource: EmailLinkSource = EmailLinkSource.NONE;
    public delayBetweenPopups: boolean | undefined = undefined;
    public smartReadyModalShownByDraftExternalId: string | undefined = undefined;
    public quickStartModalShownByDraftExternalId: string | undefined = undefined;
    public smartPolicyModalShownByServiceId: number | undefined = undefined;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            mainPage: observable,
            systemDataLoaded: observable,
            setMainPage: action,
            setSystemDataLoaded: action,
            emailLinkSource: observable,
            setEmailLinkSource: action,
            delayBetweenPopups: observable,
            setDelayBetweenPopups: action,
            smartReadyModalShownByDraftExternalId: observable,
            setSmartReadyModalShownByDraftExternalId: action,
            quickStartModalShownByDraftExternalId: observable,
            setQuickStartModalShownByDraftExternalId: action,
            smartPolicyModalShownByServiceId: observable,
            setSmartPolicyModalShownByServiceId: action
        });
    }

    public setMainPage(page: MainPages | undefined) {
        this.mainPage = page;
    }

    public sendPageViewEvent(pageName: MainPages, tabName?: ProtectionMenuNameOptions | InsightsSubMenu | BronzeTabName, reportName?: string) {
        this.sendGeneralEvent(EventType.PageView, { pageName, tabName, reportName });
    }

    public sendCustomerSelectionPageViewEvent(customerName?: string) {
        this.sendGeneralEvent(EventType.PageView, { pageName: MainPages.WELCOME_PAGE, customerName });
    }

    public setSystemDataLoaded() {
        this.systemDataLoaded = true;
    }

    public setEmailLinkSource(source: EmailLinkSource) {
        this.emailLinkSource = source;
    }

    public setDelayBetweenPopups(val: boolean) {
        this.delayBetweenPopups = val;
    }

    public setSmartReadyModalShownByDraftExternalId(externalId: string | undefined) {
        this.smartReadyModalShownByDraftExternalId = externalId;
    }

    public setQuickStartModalShownByDraftExternalId(externalId: string | undefined) {
        this.quickStartModalShownByDraftExternalId = externalId;
    }

    public setSmartPolicyModalShownByServiceId(serviceId: number | undefined) {
        this.smartPolicyModalShownByServiceId = serviceId;
    }
}